import { stdObject } from "../../../data/types/stdObject";
import InnerTable from "./InnerTable";
import { useEffect } from "react";
import EditableItem from "./EditableItem";
import { useStationeryContext } from "../../../context/MainContext";

export default function PageModel() {
  const {
    isPrint,
    isDoc,
    paperData,
    actives,
    deskDiv,
    pageDiv,
    flexDir,
    scaleInfo,
    resizePage,
    pages,
    printArea,
    hasTicket,
  } = useStationeryContext();

  useEffect(() => {
    resizePage();
  }, []);

  const cPages = isPrint
    ? !Array.isArray(pages) || pages.length === 0
      ? [[]]
      : pages
    : [0];

  const checkifVisible = (status: number, index: number) => {
    if (!isPrint || hasTicket) return true;
    switch (status) {
      case 0:
        return isPrint;
      case 1:
        return index === 0;
      case 2:
        return index + 1 === cPages.length;
    }
  };

  return (
    <div
      ref={deskDiv}
      className="stationeryDesk"
      style={{
        justifyContent: flexDir[0] ? undefined : "center",
        alignItems: flexDir[1] ? undefined : "center",
      }}
    >
      <div>
        <div
          style={hasTicket ? { display: "flex", flexWrap: "wrap" } : {}}
          ref={printArea}
        >
          {cPages.map((v: stdObject, index: number) => (
            <div
              ref={pageDiv}
              key={index}
              className={isPrint ? "stationeryPaperPrint" : "stationeryPaper"}
              style={{
                width: paperData.data.ANCDOC,
                height: paperData.data.ALTDOC,
                zoom: scaleInfo,
              }}
            >
              {isDoc && <InnerTable lines={v} />}
              {paperData.parts
                .filter((e: stdObject) => e.TIPPAR !== 4 && actives[e.NUMPAR])
                .map(
                  (e: stdObject, idx: number) =>
                    checkifVisible(e.PAGPAR, index) && (
                      <EditableItem
                        key={idx}
                        e={e}
                        currPage={index + 1}
                        totalPage={cPages.length}
                        ticketData={hasTicket ? cPages[index] : {}}
                      />
                    ),
                )}
            </div>
          ))}
        </div>
        <div style={{ height: 15 }}></div>
      </div>
    </div>
  );
}
